import WithMSWProvider from './WithMSWProvider'
export default WithMSWProvider
